import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { URLS } from "../urls";
import { Form } from "react-bootstrap";
import moment from "moment";
import { fetchActionsUtil } from "../../utils";
import { toast } from "react-toastify";
import ModalLoader from "../ModalLoader";
import { DialogModal } from "../DialogModal";
import Datepicker from "react-datetime";
import TimePicker from "../TimePicker";
import { SingleDatePicker } from "../SingleDatePicker";

export function EditRoster({ show, handleClose, details, reload }, props) {
  const [isLoading, setIsLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [editDetails, setEditDetails] = useState({
    Date: moment(details?.date).format("YYYY-MM-DD"),
    employeeID: details?.employeeID,
    TimeIn: details?.TimeIn,
    TimeOut: details?.TimeOut,
    employeeName: details?.employeeName,
  });
  const [oldDate, setOldDate] = useState(
    moment(details?.date).format("YYYY-MM-DD")
  );

  const sendAction = async () => {
    try {
      setIsLoading(true);
      await fetchActionsUtil(`${URLS.backendRosterPlanning}/edit`, "POST", "", {
        oldDate,
        ...editDetails,
      });

      toast.success("Successful");
    } catch (error) {
      console.log(error);
      toast.error("Error !!! ", error.massage || "");
    } finally {
      setIsLoading(false);
      setOpenDialog(false);
      handleClose();
      reload();
    }
  };

  const editDate = (event, name) => {
    if (!event) return;
    setEditDetails((prev) => ({
      ...prev,
      [name]: moment(event).format("YYYY-MM-DD"),
    }));
  };

  const selectTime = (date, name) => {
    setEditDetails((prev) => ({
      ...prev,
      [name]: moment(date).format("HH:mm:ss"),
    }));
  };

  return (
    <Modal
      {...props}
      show={show}
      onHide={handleClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Edit {details?.employeeName} Roster</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center">
          <div className="">
            <Form.Group>
              <Form.Label style={{ fontSize: "14px" }}>Change Date</Form.Label>
              <div>
                <SingleDatePicker
                  value={editDetails?.Date}
                  filterByDateRange={editDate}
                  name="Date"
                  dateFormat="YYYY-MM-DD"
                />
              </div>
            </Form.Group>

            <div className="container">
              <div className="row justify-content-center">
                {/*  */}
                <div className="col-md-6">
                  <div className="input-group mb-3 d-flex">
                    <span className="" id="resumeHour">
                      Resumption Time
                    </span>

                    <TimePicker
                      ok={(time) => selectTime(time, "TimeIn")}
                      className="time-format"
                      value={editDetails?.TimeIn}
                    />
                  </div>
                </div>
                {/*  */}
                <div className="col-md-6">
                  <div className="input-group mb-3">
                    <span className="" id="closingHour">
                      Closing Time
                    </span>

                    <TimePicker
                      ok={(time) => selectTime(time, "TimeOut")}
                      className="time-format"
                      value={editDetails?.TimeOut}
                    />
                  </div>
                </div>
                {/*  */}
              </div>
            </div>
          </div>

          <div className="my-4">
            <button
              onClick={() => setOpenDialog(true)}
              className="btn btn-primary"
            >
              Send
            </button>
          </div>
        </div>
      </Modal.Body>

      {openDialog && (
        <DialogModal
          show={openDialog}
          proceed={sendAction}
          handleClose={() => setOpenDialog(false)}
          title="Edit Roster"
          description={`Are you sure you want to edit ${moment(
            details?.date
          )?.format("MMMM Do YYYY")} roster of ${details?.employeeName}`}
          sendTitle="Proceed"
        />
      )}

      <ModalLoader show={isLoading} />
    </Modal>
  );
}
